import React from 'react';
import './style.scss';

import { Link } from 'react-router-dom';

export default function Navbar() {
  return (
    <nav className='navbar-container'>
      <div className='nav-wrapper'>
        <div className='container'>
          <Link to='/'>
            <span className='brand-logo left'>
              <img src={require('../../img/LOGO.svg')} alt='' />
            </span>
          </Link>
          <div
            id='nav-mobile'
            className='row navbar-numbers right navbar-right hide-on-med-and-down'>
            <div className='navItem col s12'>
              <span className='small-icon small-text'>
                0800-666-5005
                <i className='material-icons tiny small-icon'>call</i>
              </span>
            </div>
            <div className='navItem col s12'>
              <span className='small-icon'>
                clientes.patagonia@smg.com.ar
                <i className='material-icons tiny small-icon'>email</i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
